/**
 * Inline progress bar used in tables to visualize a 0..1 weight next to
 * its percentage value. Clamps out-of-range inputs to [0, 1].
 */
export function Bar({ value }: { value: number }) {
	const pct = Math.max(0, Math.min(1, value)) * 100;
	return (
		<div className="h-1.5 w-20 overflow-hidden rounded-full bg-slate-800">
			<div
				className="h-full bg-emerald-400"
				style={{ width: `${pct.toFixed(2)}%` }}
			/>
		</div>
	);
}
